import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import RenderLink from './RenderLink'
import RenderTable from './RenderTable'

interface ExtendedMarkdownProps {
  className?: string
  children: any
}

const ExtendedMarkdown = ({ className, children }: ExtendedMarkdownProps) => {
  return (
    <div className={`${className} prose prose-img:mx-auto prose-video:mx-auto prose-img:rounded-lg prose-video:rounded-lg`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: RenderLink,
          table: RenderTable,
          // Change all p tag to div tag to avoid nesting problem
          p: ({ node, ...props }) => <div {...props} />
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}

export default ExtendedMarkdown